import type { Facet } from '@vs-shop/engine/capability/productListing/facetSet';
import type { IntlShape } from 'react-intl';
import { Match, Option } from 'effect';

/** Supplies tenant labels for neutral facets without backend display names. */
export const listingFacetName = (facet: Facet, intl: IntlShape): string =>
  Option.fromNullishOr(facet.name).pipe(
    Option.getOrElse(() =>
      Match.value(facet.key).pipe(
        Match.tag('Price', () =>
          intl.formatMessage({ id: 'filter.priceRange.name', defaultMessage: 'Cena' })
        ),
        Match.tag('Brand', () =>
          intl.formatMessage({ id: 'filter.brand.name', defaultMessage: 'Značky' })
        ),
        Match.tag('Taxon', () =>
          intl.formatMessage({ id: 'filter.taxon.name', defaultMessage: 'Kategorie' })
        ),
        Match.tag('StockLocation', () =>
          intl.formatMessage({
            id: 'filter.warehouse.name',
            defaultMessage: 'Skladová dostupnost na prodejnách',
          })
        ),
        Match.tag('Attribute', ({ code }) => code),
        Match.exhaustive
      )
    )
  );
